import { AppContainer } from 'shared/app/AppContainer';
import { renderApp } from 'shared/app/AppRenderer';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { initHeapCarrierGuidSync } from 'shared/helpers/Analytics';
import { LoadboardApp } from './LoadboardApp';

if (MobileAppBridge.isInjected()) {
  window.location.replace(
    window.location.href.replace('/loadboard', '/loadboard-mobile'),
  );
} else {
  initHeapCarrierGuidSync();

  renderApp(
    <AppContainer>
      <LoadboardApp />
    </AppContainer>,
  );
}
